import React from "react";
import StyledDataGrid from "styles/styledDataGrid";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import dayjs from "dayjs";

const columns = [
  {
    field: "codeGroupName",
    headerName: "Code Group",
    flex: 2,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "codeGroupVersion",
    headerName: "Version",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "codeGroupStatus",
    headerName: "Status",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "lastUpdated",
    headerName: "Last Update",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const formattedDate = params.value
        ? dayjs(params.value).format("MM/DD/YY")
        : "";
      return <span>{formattedDate}</span>;
    },
  },
  {
    field: "effectiveDate",
    headerName: "Effective",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "codeCount",
    headerName: "Code Count",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "policyCount",
    headerName: "Policy Count",
    flex: 1,
    renderCell: (params) => (
      <Link
        component={RouterLink}
        to={`/policy-details/${params.row.codeGroupKey}`} // Change route as needed
        underline="always"
        sx={{ cursor: "pointer" }}
      >
        {params.value}
      </Link>
    ),
    align: "center",
    headerAlign: "center",
  },
  {
    field: "ruleUnitCount",
    headerName: "Rule Unit Count",
    flex: 1,
    renderCell: (params) => (
      <Link
        component={RouterLink}
        to={`/procedure-details/${params.row.codeGroupKey}`} // Change route as needed
        underline="always"
        sx={{ cursor: "pointer" }}
      >
        {params.value}
      </Link>
    ),
    align: "center",
    headerAlign: "center",
  },
];

const CodingGroupsDataGrid = ({
  CustomToolbar,
  rowData,
  getRowId,
  onRowClick,
}) => {
  const navigate = useNavigate();

  const handleRowClick = (params, event) => {
    // If parent supplied a handler, use it
    if (typeof onRowClick === "function") {
      return onRowClick(params, event);
    }

    throw new Error(
      "Default behavior: navigate to a detail page using codeGroupKey is missing"
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <StyledDataGrid
        sx={{
          "& .spacer-header": { borderRight: "none" },
          "& .spacer-cell": { borderRight: "none" },
          "& .MuiDataGrid-row:hover, & .MuiDataGrid-cell:hover": {
            cursor: "pointer",
          },
        }}
        rows={rowData}
        columns={columns}
        pageSize={5}
        getRowId={getRowId}
        rowsPerPageOptions={[5, 10, 20]}
        disableSelectionOnClick
        onRowClick={handleRowClick}
        slots={{
          toolbar: CustomToolbar,
        }}
      />
    </div>
  );
};

export default CodingGroupsDataGrid;
